import React, { useState, useEffect } from "react";

const CounterCard = ({ value, label, start }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!start) {
      setCount(0);
      return;
    }

    let startTime = null;
    const duration = 1200; // animation duration in ms

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      setCount(Math.floor(progress * value));

      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }, [start, value]);

  return (
    <div className="bg-gray-800 dark:bg-gray-900 rounded-xl shadow-lg p-6 text-center transition-transform hover:scale-105 duration-300">
      <h3 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#FF8A65] via-[#FF5722] to-[#FFC107] bg-clip-text text-transparent animate-pulse">
        {count}+
      </h3>
      <p className="text-gray-400 mt-2 text-sm md:text-base">{label}</p>
    </div>
  );
};

export default CounterCard;
